/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import SegmentedControl from '../veneer/segmented_control/segmented_control';
import SegmentedControlItem from '../veneer/segmented_control_item/segmented_control_item';
import { NavigationPillProps } from './types';
import './styles.scss';
import { withAnalytics } from '@veneer/analytics';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit : Navigation Pill
 * @public
 */
const TNavigationPill: React.FC<NavigationPillProps> = ({
  id = generateID('clientos-ui-toolkit-navigation-pill'),
  options,
  onChange,
  ...rest
}) => {
  const handleChange = (event: React.SyntheticEvent, index: number) => {
    if (options[index]?.disabled) return;
    onChange?.(event, index);
  };
  return (
    <div
      className="clientos-ui-toolkit-navigation-pill"
      id={id}
    >
      <SegmentedControl
        id={`${id}__segmented-control`}
        onChange={handleChange}
        {...rest}
      >
        {options.map((option, index) => (
          <SegmentedControlItem
            id={`${id}__segmented-control__item-${index}`}
            key={index}
            icon={option.icon}
          />
        ))}
      </SegmentedControl>
    </div>
  );
};
export const NavigationPillAnalytics = withAnalytics(TNavigationPill);
export default TNavigationPill;
